import AppLayout from '../../components/AppLayout';
import LoginRegisterBody from '../../components/LoginRegisterBody';
import RegisterForm from '../../components/RegisterForm';

export default function RegisterPage() {
  return (
    <AppLayout>
      <LoginRegisterBody>
        <RegisterForm />
      </LoginRegisterBody>
    </AppLayout>
  );
}
